<template>
  <div>
    <div class="fl-sym-bg-primary fl-sym-text-white">
      <!-- REMINDER - this comp can't use the TopHeader comp since it uses emit on click. Will resolve this when I merge TopHeader into the main index -->
      <div class="fl-sym-p-5 fl-sym-relative" @click="$emit('onBack')">
        <div
            class="fl-sym-absolute fl-sym-inset-y-0 fl-sym-left-0 fl-sym-flex fl-sym-justify-center fl-sym-items-center fl-sym-pl-4 fl-sym-text-4xl fl-sym-text-white hover:fl-sym-text-opacity-75"
        >
          <img
              src="@/assets/chevron-left-thin.svg"
              width="15"
              class="chevron-left-thin"
          />
        </div>
        <img
            src="@/assets/logo.svg"
            @click="goHome"
            width="147"
            class="fl-sym-mx-auto fl-sym-cursor-pointer"
        />
      </div>
    </div>
    <div class="fl-sym-px-3 fl-sym-mt-12 fl-sym-mb-3">
      <div class="fl-sym-text-xxs fl-sym-text-dark-blue fl-sym-letter-space-08">
        SYMPTOM CHECKER
      </div>
      <div class="fl-sym-text-3xl fl-sym-font-bold">
        Does your pet have one of these common symptoms?
      </div>
      <div class="fl-sym-text-lg fl-sym-mt-6 fl-sym-text-secondary">
        Let's start with the symptom that is troubling {{ pet.name || 'your pet' }} the most.
      </div>
      <div class="fl-sym-w-full fl-sym-left-0 fl-sym-py-10 fl-sym-px-2">
        <div>
          <search-select
              :options="options"
              v-model="symptom"
              label="answer"
              placeholder="Choose a common symptom..."
          />
        </div>
      </div>
      <div class="fl-sym-mt-4" v-if="this.symptom">
        <div class="fl-sym-text-3xl fl-sym-font-bold">{{ this.symptom.answer }}</div>
        <div class="fl-sym-mt-2 description">{{ this.symptom.answer_summary_description || '' }}</div>
        <button
            type="submit"
            class="fl-sym-rounded-full fl-sym-text-white fl-sym-border-2 common-symptom-submit fl-sym-border-intermediate fl-sym-border-3 fl-sym-p-3 fl-sym-w-full fl-sym-text-sm hover:fl-sym-border-primary fl-sym-transition-all fl-sym-transition fl-sym-duration-300 fl-sym-ease-out email-password "
            @click="submitAnswer">
          <span class="fl-sym-text-dark-blue fl-sym-font-bold">
            Yes, this is correct
          </span>
          <img src="@/assets/chevron-right-thin.svg" width="8"
               class="chevron-left-thin-button fl-sym-ml-13 fl-sym-float-right fl-sym-text-primary fl-sym-font-bold">
        </button>
        <div
            class="fl-sym-text-dark-blue  fl-sym-cursor-pointer fl-sym-font-bold fl-sym-flex fl-sym-justify-center fl-sym-mt-2 back-button">
          <div class="link" @click="back">Back</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.common-symptom-submit {
  position: relative;
  top: 170px;
}

.back-button {
  margin: auto;
  position: relative;
  top: 200px;
}

.back-button:hover {
  opacity: 0.75;
}

.description {
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.12px;
}
</style>
<script>
import SearchSelect from "../form/search-select.vue"
import {mapState} from "vuex"

export default {
  props: {
    session: {
      default: null,
      type: Object,
    },
  },
  computed: {
    ...mapState({
      session_id: (state) => state.sc.session_id,
      pet: (state) => state.pet,
    }),
  },
  components: {
    SearchSelect,
  },
  mounted() {
    this.options = this.session.answers.map((answer) => {
      return answer;
    })
  },
  methods: {
    submitAnswer() {

      this.$emit('onAnswer', {answer: this.symptom.answer})
    },
    async back() {
      await this.$store.dispatch('sc/back')
      this.$forceUpdate()
    }
  },
  data() {
    return {
      options: ["list", "of", "options"],
      symptom: null,
    }
  },
}
</script>
